var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgG2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3662 41.408C79.163 3.28039 53.9879 61.257 53.9879 61.257L40 88L30.042 72.0335C30.042 72.0335 42.6633 53.3453 51.3662 41.408Z",
    fill: "#6FCF97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3662 41.408C79.163 3.28039 53.9879 61.257 53.9879 61.257L40 88L30.042 72.0335C30.042 72.0335 42.6633 53.3453 51.3662 41.408Z",
    fill: "#6FCF97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3662 41.408C79.163 3.28039 53.9879 61.257 53.9879 61.257L40 88L30.042 72.0335C30.042 72.0335 42.6633 53.3453 51.3662 41.408Z",
    fill: "#6FCF97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3662 41.408C79.163 3.28039 53.9879 61.257 53.9879 61.257L40 88L30.042 72.0335C30.042 72.0335 42.6633 53.3453 51.3662 41.408Z",
    fill: "#6FCF97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1855 58.6047C-3.94682 21.5133 26.8221 65.622 26.8221 65.622L39.9367 87.6763H23.7957C23.7957 87.6763 15.9232 70.2175 11.1855 58.6047Z",
    fill: "#6FCF97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1855 58.6047C-3.94682 21.5133 26.8221 65.622 26.8221 65.622L39.9367 87.6763H23.7957C23.7957 87.6763 15.9232 70.2175 11.1855 58.6047Z",
    fill: "#6FCF97"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1855 58.6047C-3.94682 21.5133 26.8221 65.622 26.8221 65.622L39.9367 87.6763H23.7957C23.7957 87.6763 15.9232 70.2175 11.1855 58.6047Z",
    fill: "#6FCF97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1855 58.6047C-3.94682 21.5133 26.8221 65.622 26.8221 65.622L39.9367 87.6763H23.7957C23.7957 87.6763 15.9232 70.2175 11.1855 58.6047Z",
    fill: "#6FCF97"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4785 23.3427C53.5104 -37.5524 30.9345 41.8766 30.9345 41.8766L23.0176 80.3449L46.9886 71.4831C46.9886 71.4831 49.5292 42.4083 50.4785 23.3427Z",
    fill: "#6FCF97"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4785 23.3427C53.5104 -37.5524 30.9345 41.8766 30.9345 41.8766L23.0176 80.3449L46.9886 71.4831C46.9886 71.4831 49.5292 42.4083 50.4785 23.3427Z",
    fill: "#6FCF97"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4785 23.3427C53.5104 -37.5524 30.9345 41.8766 30.9345 41.8766L23.0176 80.3449L46.9886 71.4831C46.9886 71.4831 49.5292 42.4083 50.4785 23.3427Z",
    fill: "#6FCF97"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4785 23.3427C53.5104 -37.5524 30.9345 41.8766 30.9345 41.8766L23.0176 80.3449L46.9886 71.4831C46.9886 71.4831 49.5292 42.4083 50.4785 23.3427Z",
    fill: "#6FCF97"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG2);
export default __webpack_public_path__ + "static/media/g2.cc3c88ae.svg";
export { ForwardRef as ReactComponent };